module.exports = __webpack_public_path__ + "static/media/boots.1ede07db.jpg";